<template>
  <div
    class="item"
    :style="itemStyle"
    @click="collapsed = !collapsed"
  >
    <div
      class="question flex justify-between items-center"
      :style="questionStyle"
    >
      <div>{{ question }}</div>
      <q-icon
        name="add"
        size="md"
        :style="`color: ${itemsStyle.itemsIconColor}`"
      />
    </div>
    <div
      v-if="!collapsed"
      class="answer q-mt-md"
      :style="answerStyle"
    >
      {{ answer }}
    </div>
  </div>
</template>
<script>
import { hasProperty } from 'common/helpers/objectHelper';

export default {
  name: 'FAQItem',
  props: {
    question: {
      type: String,
      required: true,
    },
    answer: {
      type: String,
      required: true,
    },
    itemsStyle: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      collapsed: true,
    };
  },
  computed: {
    answerStyle() {
      if (hasProperty(this.itemsStyle, 'answerFontSize')) {
        return {
          color: this.itemsStyle.answerFontColor,
          fontSize: `${this.itemsStyle.answerFontSize}px`,
        };
      }
      return this.questionStyle;
    },
    questionStyle() {
      return {
        color: this.itemsStyle.itemsFontColor,
        fontSize: `${this.itemsStyle.itemsFontSize}px`,
      };
    },
    itemStyle() {
      if (this.itemsStyle.itemsBorder) {
        return {
          borderBottom: `1px solid ${this.itemsStyle.itemsBorderColor}`,
        };
      }
      return {};
    },
  },
};
</script>

<style lang="scss" scoped>
.item {
  cursor: pointer;
  padding: 20px 0;
}
</style>
